module.exports = __webpack_public_path__ + "img/ic_succeed@2x.V0.1.0_202607150932.png";